import { SwitchRolesPageService } from '@/pages/SwitchRoles/services';
import { VApplication, vappContainer } from '../../../../../application';
import { logger as log } from '@common/logger';

const MODULE_NAME = 'switchRoles.machines.states.getUserRoles';

const getSrv = () => {
  return vappContainer.get<SwitchRolesPageService>(
    SwitchRolesPageService.displayName
  );
};

export const getUserRoles = async (context: any, event: any) => {
  const currentState = 'GET_USER_ROLES';
  const method = 'getUserRoles';
  console.log('reached->');
  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      console.log('Machine Called Now');

      const srv = getSrv();
      const content = await srv.agent.getUserRoles(event?.payload);

      if (content) {
        return resolve({
          key: 'GET_USER_ROLES_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Get User Roles failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'GET_USER_ROLES_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'GET_USER_ROLES_FAILED',
        value: err?.message,
      });
    }
  });
};
